import React from 'react'

const CareCard = ({data, style}: any) => {
  return (
    <div className={`rounded-[12px] ${(data.title || data.img) && "bg-raspberry-10"} w-[276px] sm:w-full !h-[194px] md:w-[277px] lg:w-[277px] xl:w-[277px] 2xl-[277px] mx-0 md:mx-auto p-[24px] relative ${style}`}>
        <h3 className='text-[16px] leading-[24px] font-semibold font-demi'>{data.title.toUpperCase()}</h3>
        <div className='flex gap-x-[7px] mt-[24px]'>
            {data.firstLogo &&
                <img
                    src={data.firstLogo}
                    alt="logo1"
                    width={70}
                    height={70}
                />
            }

            {data.secondLogo &&
                <img
                    src={data.secondLogo}
                    alt="logo2"
                    width={70}
                    height={70}
                />
            }

            {data.productImg &&
                <img
                    src={data.productImg}
                    alt="logo2"
                    className='absolute right-0 bottom-0'
                />
            }
        </div>
    </div>
  )
}

export default CareCard